module.exports = __webpack_public_path__ + "img/sichuan.2c03a3ba.png";